import React from 'react';
import { Shield, Heart, Users, Target } from 'lucide-react';
export function TrustSection() {
  const trustPillars = [{
    icon: <Shield size={32} data-id="element-405" />,
    title: 'Registered Foundation',
    description: 'RC 157857',
    color: 'text-sfrr-blue'
  }, {
    icon: <Heart size={32} data-id="element-406" />,
    title: 'Compassionate Service',
    description: 'Dignity & Empathy',
    color: 'text-sfrr-pink'
  }, {
    icon: <Users size={32} data-id="element-407" />,
    title: 'Community-Centered',
    description: 'Grassroots Impact',
    color: 'text-sfrr-green'
  }, {
    icon: <Target size={32} data-id="element-408" />,
    title: 'Transparent Operations',
    description: 'Accountable & Ethical',
    color: 'text-sfrr-yellow'
  }];
  return <section className="py-16 bg-white border-b border-gray-100" data-id="element-409">
      <div className="container mx-auto px-4" data-id="element-410">
        <p className="text-center text-gray-500 font-medium mb-8 uppercase tracking-widest text-sm" data-id="element-411">
          Our Commitment to Excellence
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-412">
          {trustPillars.map((pillar, index) => <div key={index} className="text-center p-6 rounded-xl bg-warm-ivory hover:shadow-md transition-all duration-300" data-id="element-413">
              <div className={`${pillar.color} mb-4 flex justify-center`} data-id="element-414">
                {pillar.icon}
              </div>
              <h3 className="font-bold text-charcoal mb-1 text-sm" data-id="element-415">
                {pillar.title}
              </h3>
              <p className="text-xs text-gray-600" data-id="element-416">{pillar.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}